<template>
  <div class="StudentTransferCom">
    <el-button size="small" type="primary" @click="flag = true"
      >学生转入</el-button
    >
    <el-dialog
      title="学生转入"
      :visible.sync="flag"
      :append-to-body="true"
      :center="true"
      :destroy-on-close="true"
    >
      <p class="dialog__content__title">转入学生信息搜索</p>
      <el-form
        class="wy_el_form"
        label-width="120px"
        ref="searchIntoObjForm"
        :model="searchIntoObj"
        :rules="searchIntoObjRules"
      >
        <el-form-item label="姓名:" required prop="name">
          <el-input v-model="searchIntoObj.name" size="small" />
        </el-form-item>
        <!-- prop="idCard" -->
        <el-form-item label="学生身份证号:" required prop="idCard">
          <el-input v-model="searchIntoObj.idCard" size="small" />
        </el-form-item>
        <el-form-item>
          <el-button
            @click="SubmitsearchIntoObjForm('searchIntoObjForm')"
            size="small"
            type="primary"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>
      <template v-if="studentItemObj.rosterNo">
        <p class="dialog__content__title">学生信息</p>
        <el-form label-width="120px" class="wy_el_form">
          <el-form-item label="所在学校名称">
            {{ studentItemObj.schoolName }}
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="学生姓名:">
                {{ studentItemObj.name }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性别:">
                {{ studentItemObj.sex ? "女" : "男" }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="学生学籍号:">
            {{ studentItemObj.rosterNo }}
          </el-form-item>
          <el-form-item label="就读班级:">
            {{ studentItemObj.gradeName }} {{ studentItemObj.className }}
          </el-form-item>
        </el-form>
      </template>
      <template v-if="studentItemObj.rosterNo">
        <p class="dialog__content__title">选择转入的班级</p>
        <el-form
          class="wy_el_form"
          label-width="120px"
          :model="IntoStudentClassInfo"
          ref="IntoStudentClassInfo"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="年级:"
                prop="gradeId"
                required
                :rules="[{ required: true, message: '年级不能为空' }]"
              >
                <el-select
                  v-model="IntoStudentClassInfo.gradeId"
                  @change="value => changeclassesList(value)"
                  size="small"
                >
                  <el-option
                    v-for="item in gradeList"
                    :key="item.gradeId"
                    :label="item.name"
                    :value="item.gradeId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="班级:"
                prop="classesId"
                required
                :rules="[{ required: true, message: '年级不能为空' }]"
              >
                <el-select
                  :disabled="IntoStudentClassInfo.gradeId == ''"
                  v-model="IntoStudentClassInfo.classesId"
                  size="small"
                >
                  <el-option
                    v-for="item in classesList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
      <footer class="dialog__footer" slot="footer">
        <el-row type="flex" justify="end">
          <el-button size="small" @click="hidedialogflag">取消</el-button>

          <el-button size="small" type="primary" @click="ApiSaveTransferInfo"
            >确定</el-button
          >
        </el-row>
      </footer>
    </el-dialog>
  </div>
</template>
<script>
import { getInfoByIdCard,saveTransferInfo  } from "@/api/home";
export default {
  name: "StudentTransferCom",
  props: {
    relationList: {
      type: Array
    },
    gradeList: {
      type: Array
    },
    nationList: {
      type: Array
    },
    Select: {
      type: Array
    },
    basedata: {
      type: Array
    },
    schoolId: {
      type: [Number, String]
    }
  },
  data() {
    let checkidCard = (rule, value, callback) => {
      let _id_reg = /^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}[\dXx]$/;
      if (!value) {
        return callback(new Error("身份证号不能为空"));
      } else if (!_id_reg.test(value)) {
        callback(new Error("请填写正确的身份证号"));
      } else {
        callback();
      }
    };
    return {
      flag: false,
      searchIntoObj: {
        // 搜索转入学生
        name: "",
        idCard: ""
      },
      searchIntoObjRules: {
        // 转入学生规则
        name: [
          {
            required: true,
            message: "姓名不能为空",
            trigger: ["blur", "change"]
          }
        ],
        idCard: [
          {
            // message: "身份证号码不能为空",
            validator: checkidCard,
            trigger: ["blur", "change"]
          }
        ]
      },
      studentItemObj: {
        id: "",
        name: "", // 姓名
        rosterNo: "", // 学籍号
        address: "", // 家庭住址
        birth: "", // 生日
        idCard: "", // 身份证号码
        nation: "汉族", // 民族
        nativePlace: "", // 籍贯
        politics: "", // 政治面貌
        sex: "", // 性别
        gradeId: "", // 年级
        classId: "", // 班级
        className: "",
        gradeName: "",
        parent: {
          name: "",
          mobile: "",
          relation: ""
        },
        schoolId: "",
        schoolName: ""
      },
      classesList: [],
      IntoStudentClassInfo: {
        // 转入学生class info
        schoolId: "",
        gradeId: "", // 年级
        classesId: "" // 班级
      },
      School: []
    };
  },
  methods: {
    SubmitsearchIntoObjForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // this.ApiSaveStudent();
          getInfoByIdCard({ ...this.searchIntoObj }).then(res => {
            if (res.data != {}) {
              this.$nextTick(() => {
                this.studentItemObj = res.data.data;
                console.log('this.studentItemObj',this.studentItemObj);
              });
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          this.$message.error("请检查信息是否填写正确");
          return false;
        }
      });
    },
    // 保存学生转入信息
    ApiSaveTransferInfo() {
      if (this.studentItemObj.rosterNo === "") {
        this.$message.error("暂时没有要转入的学生");
        return false;
      }
      if (this.IntoStudentClassInfo.gradeId === "") {
        this.$message.error("请选择要转入的年级");
        return false;
      }
      if (this.IntoStudentClassInfo.classesId === "") {
        this.$message.error("请选择要转入的班级");
        return false;
      }
      let new_classname;
      this.classesList.forEach(k => {
        if (k.id == this.IntoStudentClassInfo.classesId) {
          new_classname = k.title;
        }
      });

      const data = {
        old_schoolid: this.studentItemObj.schoolId,
        old_classid: this.studentItemObj.classId,
        old_classname: this.studentItemObj.className,
        new_classid: this.IntoStudentClassInfo.classesId,
        new_classname: new_classname,
        new_schoolid: this.schoolId,
        student_id: this.studentItemObj.id,
        student_idcard: this.studentItemObj.idCard,
        student_name: this.studentItemObj.name
      };

      saveTransferInfo({ ...data }).then(async res => {
        this.$message.success("保存学生转入成功");
        this.hidedialogflag();
        await this.$emit("updateList");
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    hidedialogflag() {
      this.flag = false;
      this.IntoStudentClassInfo = {
        schoolId: "",
        gradeId: "", // 年级
        classesId: "" // 班
      };
      (this.studentItemObj = {
        id: "",
        name: "", // 姓名
        rosterNo: "", // 学籍号
        address: "", // 家庭住址
        birth: "", // 生日
        idCard: "", // 身份证号码
        nation: "汉族", // 民族
        nativePlace: "", // 籍贯
        politics: "", // 政治面貌
        sex: "", // 性别
        gradeId: "", // 年级
        classId: "", // 班级
        className: "",
        gradeName: "",
        parent: {
          name: "",
          mobile: "",
          relation: ""
        },
        schoolId: "",
        schoolName: ""
      }),
        // this.resetForm("IntoStudentClassInfo");

        this.resetForm("searchIntoObjForm");
    },
    changeclassesList(value) {
      this.gradeList.map(item => {
        if (item.gradeId == value) {
          this.classesList = item.classesList;
        }
      });
      // this.classesList = value.classesList;
    },
    // 学校列表
    // ApiSchoolList() {
    //   SchoolList({}).then(res => {
    //     this.School = res.data.dataList;
    //   });
    // }
  },
  mounted() {
    // this.ApiSchoolList();
  }
};
</script>
<style scoped>
.StudentTransferCom {
  display: inline-block;
}
.wy_el_form.el-form {
  padding: 25px;
  background-color: #eeeeee;
}
.wy_el_form.el-form .el-form-item__label {
  text-align: right !important;
}
</style>



// WEBPACK FOOTER //
// src/views/school/components/components/studentTransfer.vue